import React, { useState, useEffect } from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from "@mui/material/styles";
const SeasonsStats = ({ seasons, selectedTeam }) => {
    const [processedSeasons, setProcessedSeasons] = useState([]);
    const [gameType, setGameType] = useState(2);
    // Process the seasons data to calculate stats
    useEffect(() => {
        if (!seasons || !Array.isArray(seasons)) {
            console.error("Invalid seasons data:", seasons);
            return;
        }

        const calculateStats = seasons.map((season) => {
            let wins = 0;
            let winsOT = 0;
            let losses = 0;
            let lossesInOT = 0;
            let points = 0;
            let winsAtHome = 0;
            let winsAway = 0;
            let totalGames = 0;
            let totalOfGameAway = 0;
            let totalOfGameAHome = 0;
            let playoffs = 0;
            let winsPlayoffs = 0;

            if (season.data && Array.isArray(season.data.games)) {
                season.data.games.forEach((game) => {

                        // Playoffs
                    if ((game.homeTeam?.abbrev === selectedTeam.rawTricode || game.awayTeam?.abbrev === selectedTeam.rawTricode) && game.gameType == 3) {
                        const homeScore = game.homeTeam.score || 0;
                        const awayScore = game.awayTeam.score || 0;
                        const isHomeTeam = game.homeTeam?.abbrev === selectedTeam.rawTricode;
                        const isAwayTeam = game.awayTeam?.abbrev === selectedTeam.rawTricode;
                        if (isHomeTeam) {
                            if (homeScore > awayScore) {   
                                winsPlayoffs += 1;
                               }
                        }
                        else {
                            if (awayScore > homeScore) {   
                                winsPlayoffs += 1;
                               }
                        }
                        playoffs += 1;
                        }

                    if ((game.gameState === "FINAL" || game.gameState === "OFF") && game.gameType == 2) {
                    const homeScore = game.homeTeam.score || 0;
                    const awayScore = game.awayTeam.score || 0;
                    const isHomeTeam = game.homeTeam?.abbrev === selectedTeam.rawTricode;
                    const isAwayTeam = game.awayTeam?.abbrev === selectedTeam.rawTricode;

                        if (isHomeTeam) {
                            if (homeScore > awayScore) {                                
                                winsAtHome += 1;
                                wins += 1;
                                points += 2; // Win = 2 points
                                if(game.gameOutcome.lastPeriodType === "OT" || game.gameOutcome.lastPeriodType === "SO") {
                                    winsOT += 1;
                                }
                            } else if (game.gameOutcome.lastPeriodType === "OT" || game.gameOutcome.lastPeriodType === "SO") {
                                lossesInOT += 1;
                                points += 1; // Loss in OT = 1 point
                            } else {
                                losses += 1;
                            }
                            totalOfGameAHome += 1;
                        } else if (isAwayTeam) {
                            if (awayScore > homeScore) {
                                winsAway += 1;
                                wins += 1;
                                points += 2; // Win = 2 points
                                if(game.gameOutcome.lastPeriodType === "OT" || game.gameOutcome.lastPeriodType === "SO") {
                                    winsOT += 1;
                                }
                            } else if (game.gameOutcome.lastPeriodType === "OT" || game.gameOutcome.lastPeriodType === "SO") {
                                lossesInOT += 1;
                                points += 1; // Loss in OT = 1 point
                            } else {
                                losses += 1;
                            }

                            totalOfGameAway += 1;
                        }
                    
                }});
            }

            return {
                season: season.data?.currentSeason || "Unknown Season",
                wins,
                losses,
                lossesInOT,
                points,
                winsOT,
                winsAtHome,
                winsAway,
                totalGames: wins + losses + lossesInOT,
                totalOfGameAway,
                totalOfGameAHome,
                playoffs,
                winsPlayoffs,
            };
        });
        setProcessedSeasons(calculateStats);
    }, [seasons, selectedTeam]);



    const labelSeason = (season) => {

        season = season.toString();
        let year = season;
        let nextYear = season;
        year = year.slice(0, 4);
        nextYear = nextYear.slice(4, 8);

        return `${year}-${nextYear}`;

    }

    const WhiteTextTableCell = styled(TableCell)({
        color: "white",
        align: "right"
      });

    // Render the stats in a table
    return (
        <>
        <h2 style={{marginBottom:'30px'}}>LAST 5 SEASONS STATS</h2>
        <div style={{width:'100%'}} className='dataTableWrapper'>
            {processedSeasons.length > 0 ? (
                 <TableContainer sx={{
                    borderRadius: 2,
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                    minWidth: 800,
                  }} component={Paper}>
                    <Table  aria-label="simple table">
                        <TableHead>
                        <TableRow sx={{
                    backgroundColor: '#191919',
                    color: 'white',
                    
                  }}>
                            <WhiteTextTableCell>Season</WhiteTextTableCell>
                            <WhiteTextTableCell >Wins</WhiteTextTableCell>
                            <WhiteTextTableCell >Wins OT</WhiteTextTableCell>
                            <WhiteTextTableCell >Losses</WhiteTextTableCell>
                            <WhiteTextTableCell >Losses OT</WhiteTextTableCell>
                            <WhiteTextTableCell >Wins at Home</WhiteTextTableCell>
                            <WhiteTextTableCell >Wins away</WhiteTextTableCell>
                            <WhiteTextTableCell >Total Points</WhiteTextTableCell>
                            <WhiteTextTableCell >Games</WhiteTextTableCell>
                            <WhiteTextTableCell >Playoffs win</WhiteTextTableCell>
                        </TableRow>
                        </TableHead>
                        <TableBody>
                            {processedSeasons.map((seasonStats, index) => (
                            
                            <TableRow className={`${
                                seasonStats.winsPlayoffs === 16 ? 'seasonStats-winsPlayoffs' : ''
                              } ${
                                seasonStats.winsPlayoffs < 16 && seasonStats.playoffs > 0 ? 'seasonStats-lossesPlayoffs' : ''
                              }`}  key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                    <WhiteTextTableCell component="th" scope="row">{labelSeason(seasonStats.season)}</WhiteTextTableCell>
                                    <WhiteTextTableCell >{seasonStats.wins}</WhiteTextTableCell>
                                    <WhiteTextTableCell >{seasonStats.winsOT}</WhiteTextTableCell>
                                    <WhiteTextTableCell >{seasonStats.losses}</WhiteTextTableCell>
                                    <WhiteTextTableCell >{seasonStats.lossesInOT}</WhiteTextTableCell>
                                    <WhiteTextTableCell >{seasonStats.winsAtHome}/{seasonStats.totalOfGameAHome}</WhiteTextTableCell>
                                    <WhiteTextTableCell >{seasonStats.winsAway}/{seasonStats.totalOfGameAway}</WhiteTextTableCell>
                                    <WhiteTextTableCell >{seasonStats.points}</WhiteTextTableCell>
                                    <WhiteTextTableCell >{seasonStats.totalGames+seasonStats.playoffs}</WhiteTextTableCell>
                                    <WhiteTextTableCell >{seasonStats.winsPlayoffs}/{seasonStats.playoffs}</WhiteTextTableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            ) : (
                <p>No data available</p>
            )}
            <div className='legend'>
            <div className='seasonStats-winsPlayoffs'>Win stanley Cup</div>
            <div className='seasonStats-lossesPlayoffs'>Made the Playoffs</div>
            <div style={{background: "#3a3a3a"}} >Missed Playoffs</div>
            <div style={{background: "#ffffff", color: "#000"}} >Current Season</div>
            </div>
        </div>
        </>
    );
};

export default SeasonsStats;